/* eslint-disable */
import "../../asset/css/tab.css";
import { useEffect, useRef, useState } from "react";
import { initialTabs as tabs } from "./ingredients";
import { motion, useScroll, LazyMotion, domAnimation, AnimatePresence } from "framer-motion";
import pad1 from "../../asset/images/pad1.png";
import { wrap } from "popmotion";

import tab_1 from "../../asset/images/tab_1.png";
import tab_2 from "../../asset/images/tab_2.png";
import tab_31 from "../../asset/images/tab_31.png";
import tab_32 from "../../asset/images/tab_32.png";
import tab_33 from "../../asset/images/tab_33.png";
import tab_4 from "../../asset/images/tab_4.png";

const cardVariants = {
  onscreen: {
    transition: {
      type: "spring",
      bounce: 0.4,
      duration: 0.8,
    },
  },
};

const swipeConfidenceThreshold = 10000;
const swipePower = (offset, velocity) => {
  return Math.abs(offset) * velocity;
};

export default function Tab() {
  const scrollRef = useRef(null);

  const { scrollYProgress } = useScroll({
    target: scrollRef,
    offset: ["end end", "start start"],
  });
  // useEffect(() => {
  //   console.log(scrollYProgress);
  // }, [scrollYProgress]);

  // useMotionValueEvent(scrollY, "change", (latest) => {
  //   console.log("Page scroll: ", latest);
  // });
  const [selectedTab, setSelectedTab] = useState(0);
  const tabTitle = [
    { title: "Gongsaero\nSolution", index: 0 },
    { title: "Data Dashboard", index: 1 },
    { title: "Data Recommendation", index: 2 },
    { title: "ESG Report", index: 3 },
  ];

  console.log(selectedTab);

  const sectionVariants = {
    offscreen: {
      x: -300,
    },
    onscreen: {
      x: 0,
      transition: {
        type: "spring",
        bounce: 0.4,
        duration: 0.8,
      },
    },
  };

  const [[page, direction], setPage] = useState([0, 0]);
  const tabList = [tab_31, tab_32, tab_33];
  const imageIndex = wrap(0, tabList.length, page);

  const paginate = (newDirection) => {
    setPage([page + newDirection, newDirection]);
  };

  const variants = {
    enter: (direction) => {
      return {
        x: direction > 0 ? 1000 : -1000,
        opacity: 0,
      };
    },
    center: {
      zIndex: 1,
      x: 0,
      opacity: 1,
    },
    exit: (direction) => {
      return {
        zIndex: 0,
        x: direction < 0 ? 1000 : -1000,
        opacity: 0,
      };
    },
  };

  console.log(imageIndex);
  const slideDescList = [
    {
      first: "One-stop material procurement solution for smart city construction",
      second: 'Monitor project "process, cost, business management" at a glance with a dashboard',
      className1: "pad_desc3",
      className2: "pad_line3",
      className3: "pad_desc4",
      className4: "pad_line4",
    },
    {
      first: "Real-time monitoring management of materials ordered for smart city construction",
      second:
        "Reduce business processes and ESG impact from all automatically generated materials procurement documents",
      className1: "pad_desc5",
      className2: "pad_line5",
      className3: "pad_desc6",
      className4: "pad_line6",
    },
    {
      first: "Tagging for supplier matching optimized for smart city construction sites",
      second: "Recommendation of matching algorithms for suppliers near smart city construction sites",
      className1: "pad_desc7",
      className2: "pad_line7",
      className3: "pad_desc8",
      className4: "pad_line8",
    },
  ];

  // const { scrollYProgress } = useScroll();
  return (
    <>
      <motion.div
        className="window"
        initial="offscreen"
        whileInView="onscreen"
        variants={cardVariants}
        viewport={{ once: false, amount: 0.8 }}
      >
        <nav>
          <ul className="main_tab">
            {tabTitle.map((item, i) => {
              return (
                // 큐 tab안에 내용이 바뀌게 만들기
                <motion.li
                  key={item.index}
                  className={item.index === selectedTab ? "selected main_tab_list" : "main_tab_list"}
                  onClick={() => {
                    setSelectedTab(i);
                  }}
                >
                  <span className="pad_tab_title">{item.title}</span>
                  {item.index === selectedTab ? <motion.div className="underline" layoutId="underline" /> : null}
                </motion.li>
              );
            })}
          </ul>
        </nav>
        <main>
          <motion.div ref={scrollRef} initial={{ opacity: 0 }} animate={{ opacity: 1 }} viewport={{ once: false }}>
            <div className="pad_container">
              {selectedTab === 0 && (
                <div className="pad_division">
                  <LazyMotion features={domAnimation}>
                    <motion.img
                      src={tab_1}
                      initial={{ x: -500 }}
                      animate={{ x: 0 }}
                      className="pad_img"
                      loading="lazy"
                    />
                  </LazyMotion>
                </div>
              )}

              {selectedTab === 1 && (
                <div className="pad_division">
                  <AnimatePresence initial={false} custom={direction}>
                    <motion.img
                      // key={imageIndex}
                      src={tabList[imageIndex]}
                      custom={direction}
                      className="pad_img"
                      variants={variants}
                      initial="enter"
                      animate="center"
                      exit="exit"
                      transition={{
                        x: { type: "spring", stiffness: 300, damping: 30 },
                        opacity: { duration: 0.2 },
                      }}
                      drag="x"
                      dragConstraints={{ left: 0, right: 0 }}
                      dragElastic={1}
                      onDragEnd={(e, { offset, velocity }) => {
                        const swipe = swipePower(offset.x, velocity.x);

                        if (swipe < -swipeConfidenceThreshold) {
                          paginate(1);
                        } else if (swipe > swipeConfidenceThreshold) {
                          paginate(-1);
                        }
                      }}
                    />
                  </AnimatePresence>
                  <div className="next" onClick={() => paginate(1)}>
                    {"‣"}
                  </div>
                  <div className="prev" onClick={() => paginate(-1)}>
                    {"‣"}
                  </div>

                  <motion.div
                    className="pad_desc_container"
                    initial={{ opacity: 0, scale: 0.7 }}
                    animate={{ opacity: 1, scale: 1 }}
                  >
                    <div className={slideDescList[imageIndex].className1}>
                      <span>{slideDescList[imageIndex].first}</span>
                      <div className={slideDescList[imageIndex].className2} />
                    </div>
                    <div className={slideDescList[imageIndex].className3}>
                      <span>{slideDescList[imageIndex].second}</span>
                      <div className={slideDescList[imageIndex].className4} />
                    </div>
                  </motion.div>
                </div>
              )}
              {selectedTab === 2 && (
                <div className="pad_division">
                  <LazyMotion features={domAnimation}>
                    <motion.img
                      initial={{ x: -500 }}
                      animate={{ x: 0 }}
                      src={tab_2}
                      className="pad_img"
                      loading="lazy"
                    />
                  </LazyMotion>

                  <motion.div
                    className="pad_desc_container"
                    initial={{ opacity: 0, scale: 0.7 }}
                    animate={{ opacity: 1, scale: 1 }}
                  >
                    <div className="pad_desc1">
                      <span>
                        Weather-based
                        <br />
                        material package recommendation
                        <br />
                        due to location of GPS on site
                      </span>
                      <div className="pad_line1" />
                    </div>
                    <div className="pad_desc2">
                      <span>
                        Prediction of essential materials
                        <br />
                        for construction project schedule based on big data
                      </span>
                      <div className="pad_line2" />
                    </div>
                  </motion.div>
                </div>
              )}
              {selectedTab === 3 && (
                <div className="pad_division">
                  <motion.img initial={{ x: -500 }} animate={{ x: 0 }} src={tab_4} className="pad_img" loading="lazy" />

                  <motion.div
                    className="pad_desc_container"
                    initial={{ opacity: 0, scale: 0.7 }}
                    animate={{ opacity: 1, scale: 1 }}
                  >
                    <div className="pad_desc9">
                      <span>Percentage of eco-friendly materials used in smart city construction projects</span>
                      <div className="pad_line9" />
                    </div>
                    <div className="pad_desc10">
                      <span>Status of Disposal and Reuse of Materials Used in Construction Projects</span>
                      <div className="pad_line10" />
                    </div>
                    <div className="pad_desc11">
                      <span>Total material procurement distance calculated from construction project</span>
                      <div className="pad_line11" />
                    </div>
                  </motion.div>
                </div>
              )}
            </div>
            {/* <div className="pad_container">{selectedTab === 0 && <img src={pad1} className="pad_img" />}</div> */}
            {/* <div className="pad_container">{selectedTab === 0 && <img src={pad1} className="pad_img" />}</div> */}
            {/* <div className="pad_container">{selectedTab === 0 && <img src={pad1} className="pad_img" />}</div> */}
          </motion.div>
        </main>

        <motion.div
          initial="offscreen"
          whileInView="onscreen"
          viewport={{ root: scrollRef }}
          className="pad_fixed_menu"
        >
          <ul className="side_tab">
            {tabTitle.map((item, i) => {
              return (
                // 큐 tab안에 내용이 바뀌게 만들기
                <motion.li
                  // whileHover={{ fontWeight: 700 }}
                  // variants={sectionVariants}
                  key={item.index}
                  className={item.index === selectedTab ? "selected_side side_tab_list" : "side_tab_list"}
                  onClick={() => {
                    setSelectedTab(i);
                  }}
                >
                  <span className="">{item.title}</span>
                </motion.li>
              );
            })}
          </ul>
        </motion.div>
      </motion.div>
    </>
  );
}
